/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';
import IPT from 'react-immutable-proptypes';
import QSRPT from '../../../propTypes';
import { checklistItemPropType } from 'edrolo/domains/exams';
import { TriStateProgressBar } from 'edrolo-style-guide';
import { Tick, Cross } from '../../../components/Icons';
import style from './ChecklistBreakdown.scss';

const getAggregatesByChecklistReflections = (
  profileQuestionResponseSummary,
  checklistItems
) => {
  const stats = checklistItems.map((checklistItem) => {
    const profileReflections = profileQuestionResponseSummary.map((row) =>
      row
        .get('checklistReflections')
        .find(
          (profileChecklistReflection) =>
            profileChecklistReflection.get('checklistItemId') ===
            checklistItem.get('id')
        )
    );

    const tickCount = profileReflections.filter(
      (reflection) => reflection && reflection.get('checked') === true
    ).size;
    const crossCount = profileReflections.filter(
      (reflection) => reflection && reflection.get('checked') === false
    ).size;
    const nullCount = profileReflections.filter(
      (reflection) =>
        !reflection || (reflection && reflection.get('checked') === null)
    ).size;

    return {
      checklistItemId: checklistItem.get('id'),
      description: checklistItem.get('description').replace(/&nbsp;/gi, ''), // strip '&nbsp;' entities
      //TODO: Strip HTML tags?
      //description: checklistItem.description.replace(/(<([^>]+)>)/gi, '').replace(/&nbsp;/gi, ''),
      tickCount,
      crossCount,
      nullCount,
    };
  });

  return stats;
};

const ChecklistReflectionProgress = ({ tickCount, crossCount, nullCount }) => {
  const total = tickCount + crossCount + nullCount;

  const tickCountTooltipText = `${tickCount} out of ${total} students addressed this item in their response.`;
  const crossCountTooltipText = `${crossCount} out of ${total} students have not addressed this item in their response.`;
  const nullCountTooltipText = `${nullCount} out of ${total} students have not completed this item's self assessment.`;

  return (
    <TriStateProgressBar
      negativeCount={crossCount}
      nullCount={nullCount}
      positiveCount={tickCount}
      order={['positive', 'null', 'negative']}
      tooltipText={`${nullCount} students need help etc.`}
      className={style.progressBar}
      nullCountClassName={cx({ [style.nullCount]: !!nullCount })}
      positiveCountClassName={cx({ [style.tickCount]: !!tickCount })}
      negativeCountClassName={cx({ [style.crossCount]: !!crossCount })}
      nullCountTooltipText={nullCountTooltipText}
      positiveCountTooltipText={tickCountTooltipText}
      negativeCountTooltipText={crossCountTooltipText}
      showNullCountValue={false}
      showPositiveCountValue
      showNegativeCountValue
    />
  );
};

export const ChecklistBreakdown = ({
  profileQuestionResponseSummary,
  checklistItems,
}) => {
  if (!profileQuestionResponseSummary || !checklistItems) {
    return <p>No Data</p>;
  }

  const stats = getAggregatesByChecklistReflections(
    profileQuestionResponseSummary,
    checklistItems
  );

  return (
    <div className={cx(style.container)}>
      <ul>
        <div>
          <Tick className={style.tickIcon} />
          <Cross className={style.crossIcon} />
        </div>
        {stats.map(
          ({
            checklistItemId,
            description,
            tickCount,
            crossCount,
            nullCount,
          }) => {
            return (
              <li
                key={checklistItemId}
                data-test={`reviewing-checklist-item-${checklistItemId}`}
              >
                <span dangerouslySetInnerHTML={{ __html: description }} />
                <ChecklistReflectionProgress
                  tickCount={tickCount}
                  crossCount={crossCount}
                  nullCount={nullCount}
                />
              </li>
            );
          }
        )}
      </ul>
    </div>
  );
};

ChecklistBreakdown.propTypes = {
  profileQuestionResponseSummary: IPT.listOf(
    QSRPT.ProfileQuestionResponseSummaryRow
  ).isRequired,
  checklistItems: IPT.listOf(checklistItemPropType).isRequired,
};
